export enum FormationLevelEnum {
  Medio = 1,
  Superior = 2,
  Especializacao = 4,
  Mestrado = 5,
  Doutorado = 6
}
